import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {defaultEditorConfig, fullOptionsEditorConfig} from '../../common/html-editor.config';
import {createDefaultDialogConfig} from '../../common/dialog-utils';
import {EditTitleDescriptionConfig} from './edit-title-description-config.model';
import {filter} from 'rxjs/operators';
import {RichTextEditorComponent} from '../rich-text-editor/rich-text-editor.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {NgIf} from '@angular/common';
import {AiGlobalChatService} from '../../ai-global-chat/ai-global-chat.service';

// // disabled emoji support, the image is too large (7MB) and blocks mobile devices while downloading
// import 'quill-emoji/dist/quill-emoji.js';
@Component({
    selector: 'edit-title-description-dialog',
    templateUrl: './edit-title-description-dialog.component.html',
    styleUrls: ['./edit-title-description-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, NgIf, MatFormFieldModule, MatInputModule, RichTextEditorComponent, MatButtonModule, TranslateModule]
})
export class EditTitleDescriptionDialogComponent implements OnInit, AfterViewInit {

  dialogTitle: string;
  title: string;
  description: string;
  showTitle: boolean;
  titlePlaceHolder: string;
  descriptionPlaceholder: string;
  mode: "rich-text" | "plain-text";
  form: FormGroup;
  editorConfig: any;
  saveButtonText: string ;
  aiChatConfig: any;
  helpHintText: string;
  descriptionText: string = "";

  @ViewChild("editor")
  editor: RichTextEditorComponent;

  @ViewChild("plainText")
  plainText: ElementRef;

  constructor(
    private dialogRef: MatDialogRef<EditTitleDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    private fb: FormBuilder,
    private aiChat: AiGlobalChatService) {

    this.dialogTitle = data.dialogTitle;
    this.title = data.title;
    this.description = data.description;
    this.mode = data.mode ?? "rich-text";
    this.aiChatConfig = data.aiChatConfig;


    this.editorConfig = data.editorConfig ? data.editorConfig : defaultEditorConfig();

    this.showTitle = data.hasOwnProperty("showTitle") ? !!data.showTitle : true;

    this.titlePlaceHolder = data.titlePlaceHolder ? data.titlePlaceHolder : 'Type here the title...';

    this.descriptionPlaceholder = data.descriptionPlaceholder ? data.descriptionPlaceholder : 'Type here the description...';

    this.saveButtonText = data.saveButtonText ? data.saveButtonText : 'Save';

    const formConfig = {

    };

    if (this.showTitle) {
      formConfig['title'] = ['', [Validators.required, Validators.required]];
    }

    this.form = this.fb.group(formConfig);


  }

  ngOnInit() {
    this.helpHintText = this.aiChatConfig?.helpHintText;
  }

  ngAfterViewInit() {

    if (this.title || this.description) {

      this.form.patchValue({
        title: this.title,
      });

      if (this.mode == "rich-text") {
        this.editor.html = this.description;
      }
      else {
        this.plainText.nativeElement.value = this.description;
      }

    }

  }

  save() {

    const val = this.form.value;

    if (this.mode == "rich-text") {
      this.descriptionText = this.editor.getHtml();
    }
    else {
      this.descriptionText = this.plainText?.nativeElement?.value;
    }

    this.descriptionText = this.descriptionText.replace(new RegExp("<p><br></p><pre", 'g'), "<pre");

    this.dialogRef.close({
      title: val.title,
      description: this.descriptionText
    });

  }

  close() {
    this.dialogRef.close();
  }


  setFocus(editor: any) {
    editor.focus();
  }

  openAiChat():any  {

    this.close();

    this.aiChat.startGlobalAiChatSession({
      promptId: this.aiChatConfig.promptId,
      promptParams: this.aiChatConfig.promptParams,
      welcomeMessage: this.aiChatConfig.welcomeMessage,
      initialUserMessage: `${this.aiChatConfig.initialUserMessage} ${this.descriptionText}`,
      chatOutputCallBack: (output) => {
        alert('chat output received: ' + JSON.stringify(output));
      }
    });
  }
}

export function openEditTitleDescriptionDialog(dialog: MatDialog, config: EditTitleDescriptionConfig) {

  const dialogConfig = createDefaultDialogConfig();

  dialogConfig.width = '770px';
  dialogConfig.data = config;


  if (!config.editorConfig) {
    dialogConfig.data.editorConfig = fullOptionsEditorConfig();
  }

  return dialog.open(EditTitleDescriptionDialogComponent, dialogConfig)
    .afterClosed()
    .pipe(
      filter(result => !!result)
    );
}


